export * from './copyright-footer.component';
